import { useState, useEffect } from 'react';
import { Files } from 'helpers/FileHelpers';

export const useDocumentFile = (
  fileName: string | undefined, 
  setFileName: React.Dispatch<React.SetStateAction<string | undefined>>, 
  setIsFileAttached: React.Dispatch<React.SetStateAction<boolean>>,
  setError: (error: string | null) => void,
  setOriginalFileName?: React.Dispatch<React.SetStateAction<string | null>>, 
  setFileContent?: React.Dispatch<React.SetStateAction<string | null>>, 
) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const validateFile = async (fileName: string | null) => {
    if (!fileName) return false;
    try {
      const response = await Files.File.Exists(fileName, "document"); 
      return response; 
    } catch (error) {
      console.error("Error validating file:", error);
      return false;
    }
  };

  // useEffect(() => {
  //   if (fileName != null) {
  //     validateFile(fileName).then((isValid) => setIsFileAttached(isValid));
  //   }
  // }, [fileName, setIsFileAttached]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      if (setOriginalFileName) {
        setOriginalFileName(file.name);
      }

      if(setFileContent) {
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result as string;
          //console.log("File content:", content);
          if (setFileContent) {
            setFileContent(content); 
          }
        };
        reader.onerror = () => {
          console.error("Error reading file:", reader.error);
          setError("Failed to read the file");
        };

        reader.readAsText(file);    
      }
      
    }
  };

  const handleFileAttach = async () => {
    if (!selectedFile) return;

    // ✅ Check file size before uploading (5MB limit)
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (selectedFile.size > MAX_FILE_SIZE_BYTES) {
      //console.log(`File size exceeds ${MAX_FILE_SIZE_MB}MB. Please choose a smaller file.`);
      return;
    }

    try {
      let uploadedFile = await Files.File.Attach(selectedFile, "document", setError);
      
      if(uploadedFile && uploadedFile.includes('/')){
        uploadedFile = uploadedFile.split("/").pop();
      }

      //console.log(`File uploaded successfully: ${uploadedFile}`);

      setFileName(uploadedFile);
      setIsFileAttached(true);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleFileDelete = async () => {
    if (!fileName) return;

    try {
      //console.log("Deleting file:", fileName);
      await Files.File.Delete(fileName, "document");
      setIsFileAttached(false);
      setSelectedFile(null);
      setFileName(''); // Set fileName to empty string after deletion
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  return {
    selectedFile,
    handleFileChange,
    handleFileAttach,
    handleFileDelete,
  };
};